var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"rating__label__star",attrs:{"viewBox":"-1 -1 2 2"}},[_c('polygon',{attrs:{"points":_vm.points(),"fill":_vm.color,"fill-rule":"nonzero"}})])}
var staticRenderFns = []

export { render, staticRenderFns }